// src/modules/competition/hooks/useCompetitionJoin.js
import { useState } from 'react';
import { useService } from '../../../shared/hooks/useService';
import { useAuth } from '../../../shared/hooks/useAuth'

export const useCompetitionJoin = (competitionId) => {
    const [alert, setAlert] = useState({ show: false, variant: '', message: '' });
    const [showAlert, setShowAlert] = useState(false);
    const { user } = useAuth();
    const service = useService();


    const joinCompetition = async () => {
        try {
            await service.joinCompetition(competitionId);
            setAlert({
                show: true,
                variant: 'success',
                message: 'Successfully joined the competition!'
            });
            setShowAlert(true);
            return true; // Return success status
        } catch (error) {
            setAlert({
                show: true,
                variant: 'danger',
                message: error.message
            });
            setShowAlert(true);
            return false; // Return failure status
        }
    };

    return { joinCompetition, alert, showAlert, setShowAlert };
};
